import { EvervaultProvider } from "@evervault/react";
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Suspense } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { Toaster } from "@/components/ui/toaster";
import { ENV } from "@/features/config";
import { LanguageDirectionProvider } from "@/features/localisation";
import { handleQueryError } from "@/lib/error-handler";
import { store, persistor } from "@/store";

import { TitleProvider } from "./title-context";

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => handleQueryError(error, query.meta),
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) =>
      handleQueryError(error, mutation.meta),
  }),
});

export const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <EvervaultProvider
          appId={ENV.EVERVAULT.APP_ID}
          teamId={ENV.EVERVAULT.TEAM_ID}
        >
          <LanguageDirectionProvider>
            <PersistGate loading={null} persistor={persistor}>
              <TitleProvider>
                <Suspense>{children}</Suspense>
              </TitleProvider>
            </PersistGate>
            <Toaster />
          </LanguageDirectionProvider>
        </EvervaultProvider>
      </Provider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};
